import axios from 'axios';
import { API_LOCAL } from '../constantes/constantes';

/**
 * Servicio para obtener las categorías disponibles para filtrado de búsqueda
 * 
 * @description Realiza una petición HTTP GET para obtener la lista de categorías
 * desde un archivo JSON estático. Las categorías se usan para filtrar los
 * resultados de búsqueda por tipo de contenido.
 * 
 * @async
 * @function getCategories
 * 
 * @returns {Promise<Array<Object>>} Promise que resuelve con un array de objetos de categoría
 * @returns {Promise<Array<{id: number, value: string, label: string}>>} Estructura de categorías:
 *   - id: Identificador único de la categoría
 *   - value: Valor interno usado para filtrado (puede ser string vacío para "Todas")
 *   - label: Texto mostrado al usuario
 * 
 * @throws {Error} Lanza error si:
 *   - La petición HTTP falla
 *   - El archivo JSON no existe
 *   - Hay problemas de conectividad
 *   - El formato del JSON es inválido
 * 
 * @example
 * // Uso en componente React
 * useEffect(() => {
 *   getCategories()
 *     .then(setCategories)
 *     .catch(error => {
 *       console.error('Error al cargar categorías:', error);
 *       setCategories([]); // Fallback a array vacío
 *     });
 * }, []);
 * 
 * @since 1.0.0
 * @author Valeria Garcia
 * 
 * @see {@link ../constantes/constantes.js} Para configuración de API_LOCAL
 * @see {@link ../components/busquedaForm/BusquedaForm.js} Componente que consume este servicio
 */
export default async function getCategories() {
  try {
    const response = await axios.get(API_LOCAL + 'categories_utv.json');
    return response.data;
  } catch (error) {
    console.error('Error al cargar el JSON:', error);
    throw error;
  }
}